'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './resident-directory.routes';

export class ResidentDirectoryComponent {
  constructor(IntegrationService, DTOptionsBuilder, $state, Config) {
    'ngInject';

    this.pageTitle = Config.getPageTitleByStateWithDefault($state.current.name, "Resident Directory");

    this.dtOptions = DTOptionsBuilder.newOptions()
      .withOption('dom', 'lBfrtip')
      .withOption('responsive', true)
      .withOption('order', [0, 'asc'])
      .withOption('buttons',[{
        extend: 'excel',
        title: 'Resident Directory'
      },{
        extend: 'csv',
        title: 'Resident Directory'
      },{
        title: 'Resident Directory',
        message: 'As of ' + moment().format("MMMM Do YYYY"),
        extend: 'pdf',
        orientation: 'landscape',
        pageSize: 'LETTER'
      },'print']);

    this.data = [];

    IntegrationService.queryResidentDirectory(data => {

      data.forEach(ppty => {

        ppty.contacts.forEach(contact => {

          this.data.push({
            firstName: contact.owner.firstName,
            middleName: contact.owner.middleName,
            lastName: contact.owner.lastName,
            unit: ppty.lotNo,
            address: [ppty.address],
            phone: contact.owner.phone,
            email: contact.owner.email
          });

        });

      });

    });
  }
}

export default angular.module('conduuApp.residentDirectory', [uiRouter])
  .config(routes)
  .component('residentDirectory', {
    template: require('./resident-directory.html'),
    controller: ResidentDirectoryComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/directories/resident/resident-directory.component.js